var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemporary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3771 18H4.62287C2.07401 18 0 16.002 0 13.5456V8.63648C0 6.18013 2.07401 4.18213 4.62287 4.18213H13.3771C15.926 4.18213 18 6.18013 18 8.63648V13.5456C18 16.002 15.926 18 13.3771 18Z",
    fill: "#0083FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02322 1.27124C6.73676 1.27124 4.88322 3.12099 4.88322 5.40277V8.05119C4.88322 8.40223 4.59806 8.68681 4.2463 8.68681C3.89454 8.68681 3.60938 8.40223 3.60938 8.05119V5.40277C3.60938 2.4189 6.03324 0 9.02322 0C12.0132 0 14.4371 2.4189 14.4371 5.40277V8.05119C14.4371 8.40223 14.1519 8.68681 13.8001 8.68681C13.4484 8.68681 13.1632 8.40223 13.1632 8.05119V5.40277C13.1632 3.12099 11.3097 1.27124 9.02322 1.27124Z",
    fill: "#0083FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0549 15.0001C19.0549 17.2401 17.2391 19.0559 14.9992 19.0559C12.7592 19.0559 10.9434 17.2401 10.9434 15.0001C10.9434 12.7602 12.7592 10.9443 14.9992 10.9443C17.2391 10.9443 19.0549 12.7602 19.0549 15.0001Z",
    fill: "#0083FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 15C20 17.7614 17.7614 20 15 20C12.2386 20 10 17.7614 10 15C10 12.2386 12.2386 10 15 10C17.7614 10 20 12.2386 20 15ZM15 19.0558C17.24 19.0558 19.0558 17.24 19.0558 15C19.0558 12.76 17.24 10.9442 15 10.9442C12.76 10.9442 10.9442 12.76 10.9442 15C10.9442 17.24 12.76 19.0558 15 19.0558Z",
    fill: "#EEF6FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.957 12.7854V15.5H17.1287",
    stroke: "#EEF6FE",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemporary);
export default __webpack_public_path__ + "static/media/temporary.ba0e4644.svg";
export { ForwardRef as ReactComponent };